(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-logo"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
	let scaledUp = true
	const logoAnim = document.getElementById('logo-anim')

	if(logoAnim) {
		window.addEventListener('scroll', () => {
			const currentScrollPos = window.scrollY;
			const threshold = 200;
	
			if(currentScrollPos > threshold && scaledUp) {
				scaledUp = false
				logoAnim.classList.remove('scale-up');
				logoAnim.classList.add('scale-down');
			} else if(currentScrollPos < threshold && !scaledUp) {
				scaledUp = true
				logoAnim.classList.remove('scale-down');
				logoAnim.classList.add('scale-up');
			}
		})
	}
});
  } catch(e) { console.error(e); }
})();

})();
